import { toast } from 'sonner';

// Surface what happened to the leaver's final-month payslip after a termination change.
export const notifyPayslipSync = (sync) => {
  if (!sync) return;
  const period = `${String(sync.month).padStart(2, '0')}/${sync.year}`;
  if (sync.status === 'updated') {
    toast.success(`${period} payslip re-prorated to ${sync.expected_eligible_days}/${sync.days_in_month} days — net RM ${Number(sync.net_salary || 0).toFixed(2)}`);
  } else if (sync.status === 'finalized_locked') {
    toast.warning(sync.message || `${period} payslip is finalized — unlock and recalculate to prorate it.`, { duration: 9000 });
  }
};
